import { useFormContext } from 'react-hook-form';
import { LuBuilding } from 'react-icons/lu';
import { TagsInput, WsColors } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const CurrentEmployersFilter = ({
  name,
  defaultValue = [],
  title,
  showAccordionIcon = false,
}: WsFilterProps) => {
  const { setValue } = useFormContext();
  return (
    <WsAccordion
      title={title ?? 'Current Employers'}
      {...(showAccordionIcon && { startIcon: <LuBuilding color={WsColors.TertiaryShades800} /> })}
    >
      <TagsInput
        onTagsChange={(value: string[]) => setValue(name, value)}
        initialValue={defaultValue}
        placeholder="Like HCL,Apple,etc... "
        multiple={true}
        size="small"
        optionsInStringArray={[]}
        name={name}
      />
    </WsAccordion>
  );
};
export default CurrentEmployersFilter;
